<template>
  <div>
    <button
      id="inicioLogin"
      type="button"
      class="btn btn-primary"
      data-toggle="modal"
      data-target="#exampleModal"
      style="font-family:arial; color:rgb(211, 211, 211);"
    >
      Login
    </button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" id="modalLinks">
        <div class="modal-content">
          <div class="modal-header" style="background-color: rgb(27, 17, 121);height:80px">
            <img src="./icono.png" alt="" style="width: 80px;" />
               <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="color:white" id="botonCerrar">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div class="modal-body" id="loginPanel">
            
         <br>
            <svg
              v-if="!authenticated"
              @click="login"
              xmlns="http://www.w3.org/2000/svg"
              width="55"
              height="35"
              fill="currentColor"
              class="bi bi-google"
              viewBox="0 0 16 16"
            >
              <path
                d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"
              />
            </svg>

            <svg
              
              
              @click="loginFacebook"
              xmlns="http://www.w3.org/2000/svg"
              width="55"
              height="35"
              fill="currentColor"
              class="bi bi-facebook"
              viewBox="0 0 16 16"
            >
              <path
                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
              />
            </svg>
        <br>
            <br /><br />
            <div
              style="
                height: 1px;
                background-color: rgba(40, 34, 77, 0.493);
                width: 60%;
                margin: 0 auto;
              "
            ></div>

            <br />
            <br />

            <div class="modal-body-form">
              <label for="correo" style="margin-right: 15px"> e-mail</label>
              <input
                type="text"
                id="correo"
                v-model="email"
                style="width: 125px"
              /><br />

              <label
                for="contraseña"
                style="margin-right: 10px; margin-top: 15px"
                >password</label
              >
              <input
                type="password"
                id="contraseña"
                style="width: 122px; margin-right: 15px"
                v-model="password"
              />
              <br />
              <br />
              <br>
              <button
                class="modal-body-form-button btn btn-primary"
                v-if="!authenticated"
                @click="loginMail"
                type="button" 
                style="font-family:arial"
               
              >
                Login
              </button>
              <br>
            </div>

            <br />
          </div>
      
        </div>
      </div>
    </div>

    <div v-if="authenticated">
      <a>Hi {{ firstName }}!</a>
      <button
        @click="logout"
        type="button"
        class="btn btn-primary"
        style="width: 80px; align-text: center"
      >
        Logout
      </button>
    </div>
  </div>
</template>
<script lang="js">

import Firebase from "./db"
import Vue from "vue"




  export default  {
   name: 'loginB',
    props: [],

    data () {
      return {

         user: {
          loggedIn: false,
          data: {}
        },
        email:"",
        password:"",
        admin:"",
        pass:""

      }
    },

      mounted: function() {
      Firebase.auth.onAuthStateChanged( user => {
        if (user) {
          this.user.loggedIn = true;
            document.getElementById("inicioLogin").style.display="none"
              document.getElementById("botonCerrar").click()
              console.log("hay usuario!!")
              
          
          this.user.data = user;
        }
        else {
          this.user.loggedIn = false;
          this.user.data = {};
                 document.getElementById("inicioLogin").style.display="block"
        }
      })
    },


   
    methods: {
      login() {
        Firebase.login();
  
      },


      loginFacebook(){
Firebase.loginFacebook();

      },


      logout() {
        Firebase.logout();
         document.getElementById("adminButton").style.display="none"
               this.$emit("carritoAcero")

      },

      loginMail(){
 
          this.admin=document.getElementById("correo").value 
          this.pass=document.getElementById("contraseña").value 


        if(this.admin==="ayalaAdmin999@gmail.com" & this.pass=== "ayala2021"){

           Vue.notify({
                  group: 'foo',
                  title: 'Now you are logged as Admin',

                })

       this.$emit("showAdmin")
       document.getElementById("botonCerrar").click()

        }
      Firebase.signUpWithEmailPassword(this.email,this.password)
      }

      
   
    },

      



   computed: {
  
  

        authenticated(){
          return this.user.loggedIn
        },
        firstName(){
          if (this.user.data.displayName) {
            return this.user.data.displayName.split(' ')[0]
          }
          return null
        }
    },
}


</script>


<style>
#inicioLogin {
  background-image: url("./double-bubble-dark.png");
}

#modalLinks svg:hover {
  transition: all 1s ease;
  color: rgb(27, 17, 121);
  
}

#modalLinks {
  width: 360px;
}

#loginPanel {
  background-image: url("greek-vase.png");
}


</style>